// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"21":"change-password","563":"content","571":"settings","858":"custom-urls","929":"distributions"}[chunkId] || chunkId) + "." + {"21":"3d53fa0b","45":"ef97e932","563":"66a26f24","571":"cce51c0d","858":"82b7a42a","929":"e3affe9c"}[chunkId] + ".js";
};